import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import './assets/dtm.scss'
import VueScrollTo from 'vue-scrollto'
import mixin from './components/Mixin.vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'

Vue.config.productionTip = false
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueScrollTo)

// Vue.use(VueAxios, axios)
// axios.defaults.baseURL= "/api"
// Vue.prototype.$axios = axios;
// Vue.prototype.$axios.defaults.headers['Content-Type'] = 'application/json; charset=utf-8'; 
                    


Vue.mixin(mixin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
